export default __webpack_public_path__ + "static/media/Punto_03_Monumento_4_Mori_e_Fortezza_Vecchia_FRA_Def.d90ce768.aac";